var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMedium(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23Z",
    fill: "#12100E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.40593 8.47266C6.42415 8.2884 6.3555 8.10628 6.22106 7.98226L4.85162 6.29389V6.04169H9.10372L12.3904 13.4187L15.2799 6.04169H19.3334V6.29389L18.1625 7.44282C18.0616 7.52157 18.0115 7.651 18.0324 7.7791V16.2209C18.0115 16.349 18.0616 16.4785 18.1625 16.5572L19.306 17.7061V17.9584H13.5544V17.7061L14.739 16.5292C14.8554 16.4101 14.8554 16.3751 14.8554 16.1929V9.36939L11.5619 17.9303H11.1168L7.28237 9.36939V15.107C7.2504 15.3483 7.32868 15.5911 7.49463 15.7656L9.03525 17.6781V17.9303H4.66675V17.6781L6.20736 15.7656C6.37211 15.5908 6.44582 15.3464 6.40593 15.107V8.47266Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedium);
export default __webpack_public_path__ + "static/media/medium.c45aa538.svg";
export { ForwardRef as ReactComponent };